import Constants from "../Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

class TokenActions {

  public update(token: string): ActionInterface {
    return {
      type: Constants.TOKEN_UPDATE,
      payload: {
        token: token
      }
    };
  }

  public failToken(err): ActionInterface {
    return {
      type: Constants.TOKEN_ERR,
      payload: {
        err: err
      }
    };
  }
  public successToken() {
    return {
      type: Constants.TOKEN_SUCCEEDED,
    };
  }

}

export default new TokenActions();
